import { fromJS } from "immutable";

const baseAction = "ROLES";

export function ParseRoles(roleList) {
	return (dispatch) => {
		const rolesMap = {};

		(roleList || []).forEach((role) => {
			rolesMap[role._id] = role;
		});

		dispatch({
			type: `${baseAction}:SET`,
			rolesMap: fromJS(rolesMap),
		});
	};
}
